
import appHost, { isApp, judgeHasGetBaseInfo, isAndrod } from '@/utils/app'
import { defineComponent, onMounted, ref, watch } from 'vue'
export default defineComponent({
  name: 'three-liability-insurance-index',
  setup() {
    const displayMode = ref('Portrait') // 当前模式 横竖屏 Portrait竖屏 Landscape横屏
    onMounted(async () => {
      try {
        const mode = await appHost.getDisplayMode()
        displayMode.value = mode
      } catch (error) {
        console.log('error', error)
      }
      console.log('displayMode', displayMode.value)
    })
    return {
      displayMode,
    }
  },
})
